import { doc, setDoc, collection } from '../firebase';
import { db } from '../firebase';

export const initializeFirebaseData = async (collectionName, data) => {
  try {
    const docRef = doc(collection(db, collectionName), 'singleton');
    await setDoc(docRef, data);
    return true;
  } catch (error) {
    console.error(`Error initializing ${collectionName} data:`, error);
    return false;
  }
};

export const updateFirebaseData = async (collectionName, data) => {
  try {
    const docRef = doc(collection(db, collectionName), 'singleton');
    await setDoc(docRef, data, { merge: true });
    return true;
  } catch (error) {
    console.error(`Error updating ${collectionName} data:`, error);
    return false;
  }
}; 